import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Building = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.6375 6.81133C5.52704 6.81133 5.4375 6.90087 5.4375 7.01132V7.61133C5.4375 7.72178 5.52704 7.81133 5.6375 7.81133H6.2375C6.34796 7.81133 6.4375 7.72178 6.4375 7.61133V7.01132C6.4375 6.90087 6.34796 6.81133 6.2375 6.81133H5.6375Z"
        fill="currentColor"
      />
      <path
        d="M7.5 7.01132C7.5 6.90087 7.58954 6.81133 7.7 6.81133H8.3C8.41046 6.81133 8.5 6.90087 8.5 7.01132V7.61133C8.5 7.72178 8.41046 7.81133 8.3 7.81133H7.7C7.58954 7.81133 7.5 7.72178 7.5 7.61133V7.01132Z"
        fill="currentColor"
      />
      <path
        d="M9.76299 6.81133C9.65253 6.81133 9.56299 6.90087 9.56299 7.01132V7.61133C9.56299 7.72178 9.65253 7.81133 9.76299 7.81133H10.363C10.4734 7.81133 10.563 7.72178 10.563 7.61133V7.01132C10.563 6.90087 10.4734 6.81133 10.363 6.81133H9.76299Z"
        fill="currentColor"
      />
      <path
        d="M5.4375 4.7797C5.4375 4.66924 5.52704 4.5797 5.6375 4.5797H6.2375C6.34796 4.5797 6.4375 4.66924 6.4375 4.7797V5.3797C6.4375 5.49015 6.34796 5.5797 6.2375 5.5797H5.6375C5.52704 5.5797 5.4375 5.49015 5.4375 5.3797V4.7797Z"
        fill="currentColor"
      />
      <path
        d="M7.7 4.5797C7.58954 4.5797 7.5 4.66924 7.5 4.7797V5.3797C7.5 5.49015 7.58954 5.5797 7.7 5.5797H8.3C8.41046 5.5797 8.5 5.49015 8.5 5.3797V4.7797C8.5 4.66924 8.41046 4.5797 8.3 4.5797H7.7Z"
        fill="currentColor"
      />
      <path
        d="M9.56299 4.7797C9.56299 4.66924 9.65253 4.5797 9.76299 4.5797H10.363C10.4734 4.5797 10.563 4.66924 10.563 4.7797V5.3797C10.563 5.49015 10.4734 5.5797 10.363 5.5797H9.76299C9.65253 5.5797 9.56299 5.49015 9.56299 5.3797V4.7797Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.98315 3C2.98315 2.44772 3.43087 2 3.98315 2H12.0168C12.5691 2 13.0168 2.44772 13.0168 3V13C13.0168 13.5523 12.5691 14 12.0168 14H3.98315C3.43087 14 2.98315 13.5523 2.98315 13V3ZM4.23315 12.75V3.25H11.7668V12.75H9.95722V9.62783C9.95722 9.17219 9.58785 8.80283 9.13222 8.80283H6.86772C6.41209 8.80283 6.04272 9.17219 6.04272 9.62783V12.75H4.23315ZM7.29272 12.75H8.70722V10.0528H7.29272V12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Building;
